export const scannedCodeTypes = [
    'activity',
    'batch',
    'employee',
    'location',
    'container',
    'site-identifier',
] as const;

export type ScannedCodeType = (typeof scannedCodeTypes)[number];
